import { render, staticRenderFns } from "./orderItemTag.vue?vue&type=template&id=4a4a8ca2&"
import script from "./orderItemTag.vue?vue&type=script&lang=js&"
export * from "./orderItemTag.vue?vue&type=script&lang=js&"
import style0 from "./orderItemTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports